import React from 'react'
import PropTypes from 'prop-types'
import Tippy from '@tippy.js/react'

import './tippy.scss'
import './tooltip.scss'

const Tooltip = ({ children, title, description, trigger, noDelay }) => (
	<Tippy
		placement="top"
		trigger={trigger}
		animation="shift-away"
		animateFill={false}
		size="small"
		delay={noDelay ? [0, 0] : [800, 10]}
		theme="tooltip"
		ignoreAttributes
		maxWidth=""
		arrow
		content={
			<div>
				{title && <span className="tippy-content__title">{title}</span>}
				{description}
			</div>
		}
	>
		<span className="tippy-content__children">{children}</span>
	</Tippy>
)

Tooltip.propTypes = {
	children: PropTypes.node.isRequired,
	title: PropTypes.string,
	description: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object,
		PropTypes.node,
	]),
	trigger: PropTypes.string,
	noDelay: PropTypes.bool,
}

Tooltip.defaultProps = {
	title: null,
	description: null,
	trigger: 'mouseenter',
	noDelay: false,
}

export default Tooltip
